import { render, staticRenderFns } from "./createTask.vue?vue&type=template&id=f508bc84&scoped=true"
import script from "./createTask.vue?vue&type=script&lang=js"
export * from "./createTask.vue?vue&type=script&lang=js"
import style0 from "./createTask.vue?vue&type=style&index=0&id=f508bc84&prod&lang=scss&scoped=true"
import style1 from "./createTask.vue?vue&type=style&index=1&id=f508bc84&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f508bc84",
  null
  
)

export default component.exports